import { useMutation } from '@apollo/client';
import { AccountClient } from '@nile/graphql';
import UserForm from '@nile/banyan/src/Pages/Protected/Configuration/UserForm';
import { CREATE_CLIENT_USER } from '@nile/graphql/src/Mutation/client';
import { GET_CLIENT_USERS } from '@nile/graphql/src/Query/client';
import React, { useCallback, useState, useContext } from 'react';
import { toast, useUserMSPCheckHook } from '@nile/components';
import { withRouter } from 'react-router-dom';
import { TicketContext } from '@nile/mangifera/src/Contexts';

function NewUser(props) {
  const [sheetActive, setSheetActive] = useState(false);
  const context = useContext(TicketContext);
  const toggleSheetActive = useCallback(
    () => setSheetActive((sheetActive) => !sheetActive),
    []
  );

  const [createUser, { loading, error }] = useMutation(CREATE_CLIENT_USER, {
    client: AccountClient,
    onCompleted({ createClientUser }) {
      /* Close sheet container once an User created */
      //if (createUser) {
      toast('success', 'New user created successfully');
      //}
      if (props.actions.refreshTable) {
        props.actions.refreshTable();
      }
      if (props.actions.callback) {
        props.actions.callback(createClientUser);
      }
      if (props.actions?.back) {
        props.actions.back();
      } else if (props?.actions?.closeRequesterModal) {
        props.actions.closeRequesterModal();
      } else {
        back();
      }
    },
    onError() {
      // toast('error', 'Something went wrong');
    }
  });

  const back = useCallback(() => {
    context.closeTab();
  }, []); // eslint-disable-line

  const switchToEdit = useCallback((data, type) => {
    if (!props.actions.back) {
      back();
    }
    props.actions.switchMode(data, type);
  }, []);

  const actions = {
    primaryAction: createUser,
    back: props?.actions?.closeRequesterModal || back,
    switchToEdit: switchToEdit,
    actionType: props.type,
    ...props.actions
  };

  const isMSP = useUserMSPCheckHook();

  return (
    <UserForm
      accountId={props.accountId}
      newLayout={props.newLayout}
      actions={actions}
      isMSP={isMSP}
      disableClientEdit={props?.disableClientEdit}
      disableSiteEdit={props?.disableSiteEdit}
    ></UserForm>
  );
}

export default withRouter(NewUser);
